export default "__VITE_ASSET__ef865d3e__"